import { useContext } from "react";

import Context from "../../../../../context";

// ----------------------------------------------------------------------
type Props = {
	id: string;
};

export const useUpdateRadioRow = ({ id }: Props) => {
	const { state, actions } = useContext(Context);

	const updateSelectedPositions = (shares: number | null | undefined) => {
		const index = state.selectedPositions.findIndex((i) => i.id === id);
		let positions = state.selectedPositions.filter((i) => i.id !== id);

		if (index === -1 || state.selectedPositions[index].shares !== shares) {
			positions = [...positions, { id, shares }];
		}

		actions.onChangeSelectedPositions(positions);
	};

	const onSelectParcial = () => {
		updateSelectedPositions(null);
	};

	const onSelectTotal = () => {
		updateSelectedPositions(undefined);
	};

	return { onSelectParcial, onSelectTotal };
};

export default useUpdateRadioRow;
